import type { CapabilityConfig, ExtendedConstraints } from '../../../types';
import { hasValue } from '../../../utils';
import * as ControlSpec from '../control';

export const id = 'sidebar-menu-control';

export type Config = ControlSpec.Config & {
  type: typeof id;
  /**
   * Optional feature flag name. When set, the host resolves the flag for the
   * current user at add time and shows the sidebar icon only if it resolves
   * truthy. Fails closed: the icon stays hidden when resolution fails.
   */
  featureFlag?: string;
};

export enum Events {
  CustomEvent = 'sidebar-menu-control:custom-event',
}
export enum Actions {}

export type CustomEventPayload = unknown;

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple: [Events.CustomEvent, CustomEventPayload];
  eventHandlerTuple: [
    Events.CustomEvent,
    (payload: CustomEventPayload) => void,
  ];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!ControlSpec.isValidConfig(config, ['featureFlag'])) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  if (
    hasValue(config, 'featureFlag') &&
    typeof config.featureFlag !== 'string'
  ) {
    return false;
  }

  return true;
}
